import * as React from 'react'
import { useContext, useState } from 'react'
import { useAuth } from 'react-oauth2-pkce'
import { useUserProvider } from './UserProvider'

export const OnboardingContext = React.createContext()

export const OnboardingProvider = ({ children }) => {
  const [onboardingData, setOnboardingData] = useState({})
  const [refetchContent, setRefetchContent] = useState(false)
  const [refetchCounter, setRefetchCounter] = useState(false)

  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const { authService } = useAuth();
  const { user } = useUserProvider();

  const isOnboardingPage = window.location.pathname.includes("/onboarding");

  React.useEffect(() => {
    if (authService.isAuthenticated() && user?.idToken) {
      // Check if the user needs onboarding based on your criteria

      // Redirect Directives
      // Return early if user is super
      if (user?.isSuper) {
        return setNeedsOnboarding(false);
      }

      // Normal forced redirect checking
      if (typeof onboardingData?.wizard !== "undefined") {
        // if app setup wizard toggle is on and user is not on onboarding page, redirect to onboarding
        if (onboardingData?.wizard && !isOnboardingPage) {
          return setNeedsOnboarding(true);
        }

        // if app setup wizard toggle is off and user is on onboarding page, redirect to home
        else if ((!onboardingData?.wizard && isOnboardingPage)) {
          return setNeedsOnboarding(false);
        }
      }
    }
  }, [authService, isOnboardingPage, onboardingData?.wizard, user]);

  return(
    <OnboardingContext.Provider value={ {
      onboardingData,
      setOnboardingData,
      refetchContent,
      setRefetchContent,
      refetchCounter,
      setRefetchCounter,
      needsOnboarding,
      setNeedsOnboarding
    } }>
      {children}
    </OnboardingContext.Provider>
  )
}

export const useOnboardingProvider = () => {
  const context = useContext(OnboardingContext)

  if (context === undefined) {
    throw new Error('Invalid use of useDataContext')
  }

  return context
}
